<template>
    <div class="wrapper">
        <div class="orders">
            <div class="no-order" v-show='status == 0'>
                <div class="banner"></div>
                    <h2 class="title">
                        Schedule List
                    </h2>
                    <p class="caption">
                        No Scheduled order history 
                    </p>
                    <!-- <div class="btn-container">
                        <router-link class="btn-submit" to="/orders" >Apply</router-link>
                    </div> -->
            </div>
            <div class="order-element" v-show='status == 1' v-for="(element,ind) in orders.list" :key="ind" >                    
                    <div class="order-id" >
                        <span class="pname" v-text="`${element.productName}`"></span>
                        <span class="status" v-text="`${element.state_text}`"></span>
                    </div>                
                    <ul class="order-info-list">
                        <li class="oi-element">
                            <span class="left">Expect Amount</span>
                            <span class="right" v-text="`₹ ${element.expectBorrowAmount}`"></span>
                        </li>
                        <li class="oi-element">
                            <span class="left">Bank Account</span>
                            <span class="right" v-text="`${element.bankNo}`"></span>
                        </li>
                        <li class="oi-element">
                            <span class="left">Schdueled Time</span>
                            <span class="right" v-text="`${element.createTime}`"></span>
                        </li>
                        
                        <!-- <li class="oi-element">
                            <span class="left">Tenure</span>
                            <span class="right" v-text="`${element.period} days`"></span>
                        </li> -->                       
                        <li class="oi-element" v-show="element.state == 0">
                            <button class="right btn-check" @click="jumpTo(element)">View Detail</button>
                        </li>
                    </ul>
                    
            </div>
        </div>
    </div>
</template>
<script>
import { reactive, onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import { autoList } from '@api/index'
import { useLoading } from 'vue-loading-overlay'
export default {
    setup () {
        const status = ref(2)
        const router = useRouter()
        const orders = reactive({
            list:[]
        })
        const loading = useLoading()
        const jumpTo = (element) => {
                router.push({
                    path:`/schedule/${element.id}`,
                    query:{
                        "pid":element.productId
                    }
                })
            }
        onMounted(()=>{
            const loader = loading.show({
                container: null
            })            
            autoList().then((res)=>{
                loader.hide()
                if(res.code == 0) {
                    if(res.data == null) {
                       status.value = 0  
                    }                 
                    if(res.data.length) {
                         orders.list = res.data.map((element)=>{
                            if(element.state == 0) {
                                element.state_text = "Scheduled"
                            } else if (element.state == 2) {
                                element.state_text = "Applied"
                            } else if (element.state == 3) {
                                element.state_text = "Canceled"
                            }
                            
                            return element
                        }) 
                        status.value = 1
                        console.log(123);
                    } else {
                        status.value = 0
                    }
                }
            })
        })        
        return {
            orders,
            status,
            jumpTo
        }
    }
}
</script>
<style lang="less" scoped>
    .wrapper{
        padding:50px;
        .orders{
            .no-order{
                .banner{
                    width: 236px;
                    height: 204px;
                    background:url("~assets/images/orders/order-banner.png") no-repeat;
                    background-size: 100% 100%;
                    margin: 0 auto
                }
                .title{
                    text-align: center;
                    font-size: 44px;
                    color:#000;
                    margin: 60px 0 30px 0;
                }
                .caption{
                    padding:30px 50px;
                    color:#A59BB3;
                    font-size: 32px;
                    line-height: 1.5;
                    white-space: nowrap;
                    text-align: center;
                }
                .btn-container {
                    margin-top: 100px;            
                    width: 100%;
                    height: 96px;
                    .btn-submit {
                    display: block;
                    width: 670px;
                    height: 96px;
                    line-height: 96px;
                    text-align: center;
                    border-radius: 12px;
                    background: #BE9060;
                    font-size: 32px;
                    margin: 0 auto;
                    color: #fff;
                    &.red{
                        background:#C5340B;
                    }
                    }
                }
            }
            .order-element{
                width: 654px; 
                background: #FFFFFF;
                box-shadow: 0px 22px 80px 0px rgba(0,0,0,0.0800);
                border-radius: 16px;
                position: relative;
                margin-bottom: 50px;
                .wrapper-link{
                    position: absolute;
                    z-index:999;
                    width: 654px;
                    height:100%;
                    top:0;
                    left:0;
                    right:0;
                    bottom:0;
                }
                &.valid{
                     overflow:hidden;
                        .btn{
                            float:right;
                        }
                }
                &.invalid{
                    .order-id{
                       
                        color:#A59BB3;                        
                    }
                    .oi-element{
                        span.left{color:#A59BB3;}
                        span.right{color:#A59BB3;}
                        overflow:hidden;
                        .btn{
                            float:right;
                        }
                    }
                }
                .tag{
                    position: absolute;
                    top:0;
                    right:0;
                    width: 194px;
                    height: 106px;
                    
                    .order_state{
                        display: block;
                        width: 150px;
                        color:#fff;
                        font-size: 32px;
                        top:27px;
                        right:-5px;
                        position: absolute;  
                        text-align: center;                                              
                        transform: rotate(31deg);
                    }
                    &.invalid{
                        background:url("~assets/images/orders/invalid.png") no-repeat;
                        background-size: 100% 100%;
                    }
                    &.valid{
                        background:url("~assets/images/orders/valid.png") no-repeat;
                        background-size: 100% 100%;
                    }
                }         
                .order-id{
                    padding:30px 40px;
                    border-bottom:2px solid #EFEEF1;
                    color:#BE9060;
                    font-size: 30px;
                    height:46px;
                    line-height: 46px;
                    text-align: left;
                    display:flex;
                    justify-content: space-between;
                    align-items: center;
                    .pname{
                        font-size: 36px;
                    }
                    .status{
                        display:block;
                        padding:10px;
                        border-radius: 10px;
                        border: 2px solid #BE9060;
                        font-size: 28px;
                    }
                }
                .order-info-list{
                    padding:30px;
                    .oi-element{
                        overflow:hidden;
                        margin-bottom: 30px;
                        &:last-child{
                            margin-bottom: 0;
                        }
                        .left{
                            float:left;
                            color:#160544;
                            font-size: 32px;
                        }
                        .right{
                            float:right;
                            color:#160544;
                            font-size: 32px;
                        }
                        .btn-check{
                            display:block;
                            height: 60px;
                            border:none;
                            border-radius: 30px;
                            text-align: center;
                            font-size: 30px;
                            color:#fff;
                            background:#BE9060;
                            padding:0 20px;
                            margin-top: 30px;
                        }
                    }
                }
            }
        }
    }
</style>